import React from 'react';
import { Container, Sprite } from '@pixi/react';
import { isMobile } from '../../../core/helpers/isMobile';

function TournamentIcon({
  image,
  containerConfig,
  tournamentIconPostMessage,
  tournamentIconContainerRef,
}) {

  return (
    <Container {...containerConfig} name='GameLogo'>
      <Sprite
        ref={tournamentIconContainerRef}
        cursor='pointer'
        image={image}
        scale={isMobile() ? 0.4 : 0.6}
        anchor={0.5}
        visible={false}
        pointerdown={(e) => {
          tournamentIconPostMessage(e);
        }}
      />
    </Container>
  );
}

export default TournamentIcon;
